import moment from 'locale/momentLocale'
import React from 'react'

interface Props {
  timestamp: string
}

const Date = ({ timestamp }: Props) => <span>{moment(timestamp).format('L')}</span>

export default Date
